import React, { useEffect, useState } from 'react';
import Header from '../../components/Layout/Header';
import BackToTop from '../../components/elements/BackToTop';
import navImg1 from '../../assets/images/resources/logo1.svg';
import TermsConditionsMain from "./TermsConditionsMain";

const TermsConditions = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <Header navLogoImg={navImg1} />
            <TermsConditionsMain />
            {isVisible && <BackToTop />}
        </>
    );
};

export default TermsConditions;
